<template>
    <div class="container">
        <div class="detail">
            <div style="padding: 15rem">
                <h5>{{ data.nickname }} <van-icon :name="require('@/assets/imgs/icon20.png')" size="20" /></h5>
                <p class="subtitle">{{ data.firstTitle }}</p>
            </div>
            <div class="line"></div>
            <div class="info">
                <div class="titles">
                    <ul>
                        <li>粉丝：{{ data.fansCount }}</li>
                        <li>数字藏品：{{ total }}</li>
                        <li>关注：{{ data.followCount }}</li>
                    </ul>
                    <img :src="data.avatar">
                </div>
                <p style="margin: 10rem 0;">介绍</p>
                <div v-html="data.userIntro"></div>
            </div>
        </div>
        <div class="works">
            <span>Ta的作品</span>
            <!-- <button>作品主页</button> -->
        </div>
		<div class="list_wrap">
			<van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="getModelList" offset="100">
				<div class="waterfall-grid">
					<div class="waterfall-column" v-for="(column, index) in columns" :key="index">
						<div class="waterfall-item" v-for="item in column" :key="item.id" @click="jumpToDetail(item)">
							<AssetsCard :item="item" />
						</div>
					</div>
				</div>
			</van-list>
		</div>
    </div>
    <ShareDialog ref="shareDialog" />
    <van-floating-bubble @click="toShare()" :icon="require('@/assets/imgs/icon17.png')" style="background-color: #fff; box-shadow:0 0 10rem rgba(0, 0, 0, 0.15);" />
</template>
<script setup>
import { onMounted, reactive, ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router'
import ShareDialog from '@/views/front/components/ShareDialog.vue'
import AssetsCard from '@/views/front/components/AssetsCard.vue'
import { http } from '@/request/http'

const shareDialog = ref(null)

const router = useRouter()
const route = useRoute()
const data = reactive({

})
const modelList = ref([])
const page = ref(1)
const total = ref(0)

const loading = ref(false)
const finished = ref(false)

const columnCount = 2
const columns = computed(() => {
	const cols = Array.from({ length: columnCount }, () => [])
	modelList.value.forEach((item, index) => {
		cols[index % columnCount].push(item)
	})
	return cols
})
onMounted(() => {
    http.get('/app-api/member/user/getByMall?userId=' + route.query.id).then(res => {
        console.log(res);
        
        Object.assign(data, res)
    })
    getModelList()
})

function getModelList() {
    loading.value = true
    http.get(`/app-api/product/spu/page?name=&sortField=updateTime&sortAsc=false&pageNo=${page.value}&pageSize=10&userId=${route.query.id}&type=1`).then(res => {
        modelList.value.push(...res.list)
        page.value++
        total.value = res.total
        finished.value = res.total <= modelList.value.length
        loading.value = false
    })
}

const toShare = () => {
    shareDialog.value.show(location.href, data.nickname, 1)
}
const goBack = () => {
    if (window.history.length > 1) {
        router.back()
    } else {
        router.replace('/')
    }
}
</script>
<style scoped lang="scss">
.container {
    background-color: #F6F6F6;
    padding-bottom: 50rem;
    padding: 20rem 0;
    min-height: 100vh;
}

header {
    display: flex;
    align-items: center;
    height: 60rem;
    justify-content: space-between;
    padding: 0 20rem;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

.detail {
    margin: 0 20rem 20rem 20rem;
    background-color: #fff;

    .line {
        width: 100%;
        height: 1rem;
        background-image: url('@/assets/imgs/line.png');
        background-size: 100%;
    }

    h5 {
        font-size: 20rem;
    }

    .subtitle {
        color: #797979;
        margin-top: 10rem;
    }

    .info {
        padding: 15rem;
        min-height: 150rem;
        .titles {
            display: flex;
            justify-content: space-between;

            ul {
                width: calc(100% - 120rem);

                li {
                    color: #797979;
                    line-height: 30rem;
                    font-size: 14rem;
                }
            }

            img {
                width: 110rem;
                height: 135rem;
                object-fit: cover;
            }
        }
    }


}

.works {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15rem;
    span{
        font-weight: bold;
    }
    button{
        background-color:transparent; border: 1px solid #000000; width: 90rem; height: 26rem;
    }
}


.list_wrap{
    
}
.waterfall-grid {
	display: flex;
	padding: 15rem;
	gap: 15rem;

	.waterfall-column {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.waterfall-item {
		background: #fff;
		overflow: hidden;

		img {
			width: 100%;
			display: block;
		}

		.item-info {
			padding: 10px;

			h6 {
				font-size: 14px;
				margin: 0 0 8px 0;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.item-stats {
				display: flex;
				gap: 12px;
				font-size: 12px;
				color: #999;

				span {
					display: flex;
					align-items: center;
					gap: 4px;
				}
			}
		}
	}
}


.assets{
    display: flex; padding: 20rem 10rem;
    .item{
        width: 50%; margin: 0 5rem; background-color: #fff;
    }
}
</style>